const IconPrev = ({ size = 5, color = 'gray', className='' }) => (
  <svg
    className={`${className} w-${size} h-${size} text-${color}-500`}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.5303 18.5303C14.2374 18.8232 13.7626 18.8232 13.4697 18.5303L7.46967 12.5303C7.17678 12.2374 7.17678 11.7626 7.46967 11.4697L13.4697 
        5.46967C13.7626 5.17678 14.2374 5.17678 14.5303 5.46967C14.8232 5.76256 14.8232 6.23744 14.5303 6.53033L9.06066 12L14.5303 17.4697C14.8232 
        17.7626 14.8232 18.2374 14.5303 18.5303Z" 
    />
  </svg>

);

export default IconPrev;
